import { Box, Card, CardContent, Skeleton, Stack } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyle = makeStyles((theme) => ({
  cardContainer: {
    minWidth: "378px",
    minHeight: "104px",
    width: "100%",
    padding: "24px",
    transition: "box-shadow 200ms ease-in-out",
    cursor: "pointer",
    "&:hover": {
      boxShadow: "0px 8px 12px #00000029",
    },
  },
}));

export const ClassListSkeleton = () => {
  const classes = useStyle();

  return (
    <>
      <Card className={classes.cardContainer}>
        <CardContent
          sx={{
            height: "100%",
            padding: "0px !important",
            display: "flex",
            flexDirection: "column",
            alignItems: "left",
          }}>
          <Box sx={{ display: "flex", flexDirection: "row", gap: "16px", width: "100%" }}>
            <Box sx={{ width: "56px", height: "56px" }}>
              <Skeleton sx={{ height: "50px" }} animation="wave" variant="rectangular" />
            </Box>
            <Stack
              direction="column"
              sx={{
                flexGrow: 1,
                flexBasis: "0",
                flexShrink: 1,
                overflow: "hidden",
                marginRight: "auto",
              }}>
              <Skeleton
                animation="wave"
                height={10}
                width="80%"
                style={{ marginBottom: 6 }}
              />
              <Stack direction="row" gap={"32px"}>
                <Skeleton animation="wave" height={10} width="20%" />
                <Skeleton animation="wave" height={10} width="20%" />
              </Stack>
            </Stack>
            <Skeleton animation="wave" variant="circular" width={40} height={40} />
          </Box>
        </CardContent>
      </Card>
    </>
  );
};
